const schoolUsers = {
  heading: "Aliflaila School Users",
  subHeading: "Manage all School Users here",
  columnsHeading: [
    { title: "School Name", id: "school_name" },
    { title: "Plan Title	", id: "plan_title" },
    { title: "Amount", id: "amount" },
    { title: "Duration", id: "duration" },
    { title: "Discount", id: "discount" },
    { title: "actions", id: "actions" }
  ],
  actions: [
    {
      id: "view",
      text: "View"
    },
    {
      id: "deactivate",
      text: "Deactivate"
    }
  ]
};

const parentUsers = {
  heading: "Aliflaila Parent Users",
  subHeading: "Manage all Parent Users here",
  columnsHeading: [
    { title: "User Name", id: "username" },
    { title: "Email", id: "email" },
    { title: "Joining Date", id: "joining_date" },
    { title: "Membership", id: "membership" },
    { title: "actions", id: "actions" }
  ],
  actions: [
    {
      id: "view",
      text: "View"
    },
    {
      id: "deactivate",
      text: "Deactivate"
    }
  ]
};

const planCategories = {
  individual: 1,
  family: 2,
  school: 3,
  balance: 4
};

const plan_category = [
  {
    label: "Individual",
    value: 1
  },
  {
    label: "Family",
    value: 2
  },

  {
    label: "School",
    value: 3
  },
  {
    label: "Top up balance",
    value: 4
  }
  // {
  //   label: "School",
  //   value: 4
  // },
];

const plan_types = [
  {
    label: "Regular",
    value: 1
  },
  {
    label: "Promotional",
    value: 2
  }
];

const plan_types_category = [
  {
    label: "General",
    value: 1
  },
  {
    label: "In-App",
    value: 2
  },
  {
    label: "International",
    value: 3
  },
  {
    label: "In-app International",
    value: 4
  }
];

const plan_status = [
  {
    label: "Inactive",
    value: 0
  },
  {
    label: "Active",
    value: 1
  }
];

export {
  schoolUsers,
  parentUsers,
  plan_status,
  plan_types_category,
  plan_types,
  plan_category,
  planCategories
};
